// @flow
import React from "react";
import {
    Row,
    Col,
    Card,
    Spinner,
} from "react-bootstrap";
// import cardImg2 from '../../../public/assets/images/small/small-4.jpg';
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { fetchArticle } from "../../../api/endpoints";
import { API_BASE_URL } from "../../../api/config";
import { useQuery } from "@tanstack/react-query";
//import Loading from "../../../components/Spinner";


const ReadBlog = () => {

    const par = useParams();

    const { isFetching, isError, data: blog, error } = useQuery({
        queryKey: ['blog-article', par.id],
        queryFn: async () => {
            return await fetchArticle(par.id);
        },
    })

    if (isFetching) {
        return (
            <div className="d-flex align-content-center justify-content-center flex-column" style={{ height: '80vh' }} >
                <Spinner className='text-center mx-auto' type="grow" />
            </div>
        )
    }

    if (isError) {
        return (
            <p>An Error Occurred : {error.message}</p>
        )
    }

    return (
        <div className=" blog-container ">

            <Row className="w-75 mx-auto ">

                <Col xl={12} lg={12}>
                    <h2 className="mb-5">AAER Blog</h2>
                    <Card>

                        <Card.Body className="py-5">
                            <h5
                                className={"meet-title light"}
                            >
                                {blog?.blog_title || ""}
                            </h5>
                            <Row className="mt-3 justify-content-center">
                                <Card.Img
                                    className="w-md-40 blog-image "
                                    src={`${API_BASE_URL}/${blog?.blog_image}`}
                                ></Card.Img>
                                <Card.Title className="mx-3 mt-2 my-5" style={{ color: "var(--grey-text)", fontSize: "18px" }}>
                                    <i className="mdi mdi-user"></i>By{" "}
                                    {blog?.written_by ? blog?.written_by
                                        : "AAER"}
                                    <br className="mb-2" />
                                    <span className="float-end" style={{ color: "var(--grey-text)", fontSize: "18px" }}>
                                        {new Date(blog?.created_at).toDateString()}
                                    </span>
                                </Card.Title>
                                <Col md={12}>
                                    <Card.Text className="fs-4 mt-1">
                                        {parse(
                                            DOMPurify.sanitize(blog?.blog_body || "", {
                                                USE_PROFILES: { html: true },
                                            })
                                        )}
                                    </Card.Text>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );

};

export default ReadBlog;
